<!-- Výchozí layout -->
<template>
  <div>
    <div v-if="globalLoading" class="text-center text-info my-2">
      <b-spinner class="align-middle"></b-spinner>
    </div>

    <div v-if="!globalLoading" class="LayoutDefault">
      <!-- Hlavička, logo, název obce -->
      <!-- Pokud je uživatel přihlášen zobrazí se také panel uživatele -->
      <div class="jumbotron mb-0 pb-0">
        <b-container>
          <b-row>
            <b-col cols="auto" >
              <LogoOrganizace />
            </b-col>
            <b-col >
              <PageHeader />
            </b-col>
          </b-row>
        </b-container>
      </div>

      <!-- menu -->
      <div v-if="!isPozastaveno" class="hlavniMenu">
        <b-container>
          <b-row class="d-flex align-items-start flex-nowrap">
            <b-col class="flex-fill">
              <PageMenu />
            </b-col>

            <b-col v-if="isGoPayPlatbyAllowed || isQrPlatbyAllowed" class="flex-shrink-1 text-right pl-0">
              <CartControl />
            </b-col>
          </b-row>
        </b-container>
      </div>

      <div v-if="maintenanceMessage != null && maintenanceMessage.length > 0"  class="maintanance">
          <span v-html="maintenanceMessage"/>
      </div>

      <!-- Panel se zobrazenou chybou HTML requestu -->
      <div class="col">
        <HtmlErrorBlock />
      </div>

      <!-- Panel se zobrazenou chybou aplikace -->
      <div v-if="errorMessage" class="col">
        <AppErrorBlock :message="errorMessage" />
      </div>

      <!-- Obsah stránky -->
      <b-container v-if="!isBusy && !isPozastaveno">
        <b-row>
          <!-- obsah -->
          <b-col cols="12" class="slotContainer">
            <slot />
          </b-col>
        </b-row>
      </b-container>

      <!-- patička -->
      <b-container v-if="!isPozastaveno" fluid>
        <b-row>
          <footer>
            <PageFooter />
          </footer>
        </b-row>
      </b-container>

      <b-container v-if="isPozastaveno">
        <b-row class="pt-3 pb-2">
          <b-col style="height: 100% !important">
            <h5 class="constructionMessage">
              <span class="material-icons-outlined constructionIcon">construction</span>
              {{ $t("error.web_disabled") }}
            </h5>
          </b-col>
        </b-row>
      </b-container>

    </div>
  </div>
</template>

<script>
import LogoOrganizace from "../components/LogoOrganizace";
import PageHeader from "../components/PageHeader";
import PageMenu from "../components/PageMenu";
import CartControl from "@/components/CartControl.vue";
import PageFooter from "../components/PageFooter";
import HtmlErrorBlock from "../components/HtmlErrorBlock";
import AppErrorBlock from "../components/AppErrorBlock";
import PaymentBanner from "../components/PaymentBanner";

import { mapState } from "vuex";

export default {
  data() {
    return {
      isBusy: false,
      maintenanceMessage: null,
      errorMessage: "",
      isQrPlatbyAllowed: null,
      isGoPayPlatbyAllowed: null,
      isPozastaveno: null
    };
  },
  errorCaptured(error, component, info) {
    this.errorMessage = error;
    console.log("An error occured:", error, component, info);
  },
  components: {
    PaymentBanner,
    LogoOrganizace,
    PageHeader,
    PageMenu,
    CartControl,
    PageFooter,
    HtmlErrorBlock,
    AppErrorBlock,
  },
  computed: mapState([
    "globalLoading",
    "isCartSelected"]),
  mounted() {
    this.isBusy = true;

    this.$backend.getMaintenanceMessage(response => {
      this.maintenanceMessage = response != null && response.status === 200 ? response.data : null

      this.$backend.getOrganizace(response => {
        this.$store.dispatch("setOrganizace", response.data);
        if (response.data != null) {
          this.isQrPlatbyAllowed = response.data.qrPlatby;
          this.isGoPayPlatbyAllowed = response.data.goPayPlatby;
          this.isPozastaveno = response.data.pozastaveno;
        }

        this.isBusy = false;
      });
    });
  },
};
</script>
